"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from "react";
import cn from "@/app/utils/cn";
import { ASK, BID } from "@/app/utils/Constants";
import toast from "react-hot-toast";
import Button from "@/app/components/UI/Button";
import Link from "next/link";
import { useRouter } from "@/app/hooks/useRouter";
import useSelectedCoinStore from "@/app/stores/useSelectedCoinStore";
import moment from "moment-jalaali";
import { useTranslations } from "next-intl";
import ReadMore from "@/app/components/Common/ReadMore";
import { useDealProcessContext } from "@/app/context/DealProcessProvider";
import { getInitialLang } from "@/app/utils/locale";
import getExchangeName from "@/app/utils/getExchangeName";
import useRoundDown from "@/app/utils/formatAmount";
import { safeParseJson } from "@/app/utils/safeJson";
import ISelectCrypto from "@/app/components/Common/ISelectCrypto/ISelectCrypto";
import isMobileView from "@/app/utils/isMobileView";
import AmountInput from "@/app/components/Common/Input/AmountInput";
import { useAuth } from "@/app/context/AuthContext";
import { useCoinsContext } from "@/app/context/MarketContext";
import { useWallet } from "@/app/context/WalletContext";
import { getExchangeFullIcon } from "@/app/utils/getExchangeFullIcon";
import { getExchangeIcon } from "@/app/utils/getExchangeIcon";
import { useExchangePdpQuery } from "@/app/apiServices/market/service";
const Index = t0 => {
  const $ = _c(89);
  const {
    exchangeName,
    lastOrders
  } = t0;
  const t = useTranslations();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getInitialLang();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const lang = t1;
  const router = useRouter();
  const {
    roundDown
  } = useRoundDown();
  const {
    token
  } = useAuth();
  const {
    coins,
    prices,
    markets
  } = useCoinsContext();
  const {
    walletAmounts
  } = useWallet();
  const {
    side,
    setSide
  } = useDealProcessContext();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [amountValue, setAmountValue] = useState(0);
  const [minMaxState, setMinMaxState] = useState(null);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [exchangeNames, setExchangeNames] = useState(t2);
  const [isMinMaxAmount, setIsMinMaxAmount] = useState(true);
  const [isChecking, setIsChecking] = useState(true);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      exchange: "",
      description: "",
      name: ""
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const [exchangesPdp, setExchangesPdp] = useState(t3);
  const {
    selectedCoin,
    setSelectedCoin
  } = useSelectedCoinStore();
  const exchangePdpQuery = useExchangePdpQuery(exchangeName);
  let t4;
  let t5;
  if ($[3] !== exchangePdpQuery.data || $[4] !== exchangePdpQuery.isSuccess || $[5] !== router) {
    t4 = () => {
      if (exchangePdpQuery.isSuccess) {
        const data = exchangePdpQuery.data?.[lang];
        if (!data || Object.keys(data).length === 0) {
          router.replace("/exchange");
        } else {
          setExchangesPdp(data);
        }
        setIsChecking(false);
      }
    };
    t5 = [exchangePdpQuery.isSuccess, exchangePdpQuery.data, lang, router];
    $[3] = exchangePdpQuery.data;
    $[4] = exchangePdpQuery.isSuccess;
    $[5] = router;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  let t6;
  if ($[8] !== markets || $[9] !== selectedCoin?.symbol) {
    t6 = () => {
      if (markets) {
        markets.map(item => {
          if (item.symbol === selectedCoin?.symbol) {
            setMinMaxState({
              ...item
            });
          }
        });
      }
    };
    $[8] = markets;
    $[9] = selectedCoin?.symbol;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== selectedCoin) {
    t7 = [selectedCoin];
    $[11] = selectedCoin;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  useEffect(t6, t7);
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      setAmountValue(0);
    };
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== side) {
    t9 = [side];
    $[14] = side;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  useEffect(t8, t9);
  let t10;
  if ($[16] !== markets || $[17] !== selectedCoin) {
    t10 = () => {
      if (markets && selectedCoin?.symbol) {
        const irtMarkets = markets.filter(_temp);
        const matchingCoin = irtMarkets.find(item_1 => item_1.symbol === selectedCoin.symbol);
        if (matchingCoin) {
          setMinMaxState({
            ...matchingCoin
          });
        }
      }
    };
    $[16] = markets;
    $[17] = selectedCoin;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== markets || $[20] !== selectedCoin || $[21] !== side) {
    t11 = [markets, selectedCoin, side];
    $[19] = markets;
    $[20] = selectedCoin;
    $[21] = side;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  useEffect(t10, t11);
  let t12;
  if ($[23] !== markets || $[24] !== setSelectedCoin) {
    t12 = () => {
      if (markets) {
        const usdtCoin = markets.find(_temp2);
        if (usdtCoin?.name) {
          setSelectedCoin(usdtCoin);
        }
        const irtMarkets_0 = markets.filter(_temp3);
        const matchingCoin_0 = irtMarkets_0.find(_temp4);
        if (matchingCoin_0) {
          setMinMaxState({
            ...matchingCoin_0
          });
        }
      }
    };
    $[23] = markets;
    $[24] = setSelectedCoin;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== markets) {
    t13 = [markets];
    $[26] = markets;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  useEffect(t12, t13);
  let t14;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = () => {
      setAmountValue(0);
    };
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== selectedCoin) {
    t15 = [selectedCoin];
    $[29] = selectedCoin;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  useEffect(t14, t15);
  let t16;
  if ($[31] !== amountValue || $[32] !== router || $[33] !== selectedCoin || $[34] !== side) {
    t16 = function handleKeyDownEvent(event) {
      if (event.key === "Enter" && amountValue && selectedCoin !== null) {
        router.push(`/comparison/?side=${side}&amount=${amountValue}&market=${selectedCoin?.symbol}`);
      }
    };
    $[31] = amountValue;
    $[32] = router;
    $[33] = selectedCoin;
    $[34] = side;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  const handleKeyDownEvent = t16;
  let t17;
  if ($[36] !== amountValue) {
    t17 = value => {
      setAmountValue(value);
      if (amountValue === undefined && value === undefined) {
        toast.error("\u0644\u0637\u0641\u0627 \u0627\u0639\u062F\u0627\u062F \u0627\u0646\u06AF\u0644\u06CC\u0633\u06CC \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F");
      }
    };
    $[36] = amountValue;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  const handleAmount = t17;
  let t18;
  if ($[38] !== amountValue || $[39] !== router || $[40] !== selectedCoin?.symbol || $[41] !== side) {
    t18 = () => {
      router.push(`/comparison/?side=${side}&amount=${amountValue}&market=${selectedCoin?.symbol}`);
    };
    $[38] = amountValue;
    $[39] = router;
    $[40] = selectedCoin?.symbol;
    $[41] = side;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  const handleSearch = t18;
  let t19;
  if ($[43] !== amountValue || $[44] !== minMaxState || $[45] !== prices || $[46] !== selectedCoin?.symbol || $[47] !== side) {
    t19 = () => {
      if (side === BID) {
        if (minMaxState) {
          setIsMinMaxAmount(amountValue < minMaxState?.min_currency || amountValue > minMaxState?.max_currency);
        } else {
          setIsMinMaxAmount(amountValue < 100000 || amountValue > 100000000);
        }
      } else {
        if (prices) {
          let coinToUsdtRate = 0;
          const usdtToIrtRate = prices.USDT?.price_in_irt;
          for (const key in prices) {
            if (key === selectedCoin?.symbol) {
              if (selectedCoin?.symbol === "USDT") {
                coinToUsdtRate = 1;
              } else {
                coinToUsdtRate = prices[key].price_in_usd;
              }
            }
          }
          if (!minMaxState) {
            const usdtAmount = amountValue * coinToUsdtRate;
            const irtAmount = usdtAmount * usdtToIrtRate;
            setIsMinMaxAmount(irtAmount > minMaxState?.min_currency || irtAmount < minMaxState?.max_currency);
          } else {
            setIsMinMaxAmount(amountValue < minMaxState.min_symbol || amountValue > minMaxState.max_symbol);
          }
        }
      }
    };
    $[43] = amountValue;
    $[44] = minMaxState;
    $[45] = prices;
    $[46] = selectedCoin?.symbol;
    $[47] = side;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  const handleMinimumCheck = t19;
  let t20;
  if ($[49] !== handleMinimumCheck) {
    t20 = () => {
      setAmountValue(_temp5);
      handleMinimumCheck();
    };
    $[49] = handleMinimumCheck;
    $[50] = t20;
  } else {
    t20 = $[50];
  }
  let t21;
  if ($[51] !== amountValue || $[52] !== selectedCoin) {
    t21 = [amountValue, selectedCoin];
    $[51] = amountValue;
    $[52] = selectedCoin;
    $[53] = t21;
  } else {
    t21 = $[53];
  }
  useEffect(t20, t21);
  let t22;
  if ($[54] !== lastOrders?.value) {
    t22 = () => {
      const fetchExchangeNames = async () => {
        const names = {};
        const list = safeParseJson(lastOrders?.value, []);
        for (const item_5 of list) {
          if (item_5.exchange && !names[item_5.exchange]) {
            names[item_5.exchange] = await getExchangeName(item_5.exchange, lang);
          }
        }
        setExchangeNames(names);
      };
      fetchExchangeNames();
    };
    $[54] = lastOrders?.value;
    $[55] = t22;
  } else {
    t22 = $[55];
  }
  let t23;
  if ($[56] !== lastOrders) {
    t23 = [lastOrders, lang];
    $[56] = lastOrders;
    $[57] = t23;
  } else {
    t23 = $[57];
  }
  useEffect(t22, t23);
  let t24;
  if ($[58] !== coins || $[59] !== selectedCoin?.symbol) {
    t24 = symbol => {
      if (coins?.length > 0 && selectedCoin?.symbol) {
        const coin = coins?.find(item_6 => item_6.symbol === symbol);
        return coin?.floating_point ?? 2;
      }
    };
    $[58] = coins;
    $[59] = selectedCoin?.symbol;
    $[60] = t24;
  } else {
    t24 = $[60];
  }
  const getFloatingPoint = t24;
  const renderHeaderExchangeIcon = _temp6;
  const renderExchangeIcon = _temp7;
  let t25;
  if ($[61] !== amountValue || $[62] !== exchangeNames || $[63] !== exchangesPdp?.description || $[64] !== exchangesPdp?.exchange || $[65] !== exchangesPdp?.name || $[66] !== getFloatingPoint || $[67] !== handleAmount || $[68] !== handleKeyDownEvent || $[69] !== handleSearch || $[70] !== isChecking || $[71] !== isDropdownOpen || $[72] !== isMinMaxAmount || $[73] !== isModalOpen || $[74] !== lastOrders?.value || $[75] !== minMaxState?.max_currency || $[76] !== minMaxState?.max_symbol || $[77] !== minMaxState?.min_currency || $[78] !== minMaxState?.min_symbol || $[79] !== roundDown || $[80] !== router || $[81] !== selectedCoin || $[82] !== setSelectedCoin || $[83] !== setSide || $[84] !== side || $[85] !== t || $[86] !== token || $[87] !== walletAmounts) {
    t25 = !isChecking ? <div className="bg-charcoal-50"><div className="md:py-10 pt-10 custom-container mx-auto px-3 xl:px-0"><div className="flex flex-col md:grid grid-cols-6 gap-[23px]"><div className="col-span-4"><div className="bg-white md:px-[60px] px-3.5 md:mt-0 mt-7 md:py-10 py-5 rounded-[20px]"><div className="flex items-center gap-4">{renderHeaderExchangeIcon(exchangesPdp?.exchange)}<div><p className="text-sm md:text-[20px] font-bold">{exchangesPdp?.exchange}</p><p className="mt-[6px] text-sm md:text-[20px] font-medium text-charcoal-600">{exchangesPdp?.name}</p></div></div><div className="bg-white px-10 py-3 md:py-9 rounded-[20px]"><ReadMore text={exchangesPdp?.description} /></div></div></div><div className="md:sticky md:top-28 col-span-2"><div className="px-3.5 py-5 md:p-6 bg-white rounded-[20px]"><div className="flex items-center border border-charcoal-300 rounded-xl p-1"><div onClick={() => setSide(BID)} className={cn(side === BID ? "text-aquamarine-400 bg-aquamarine-50" : "text-charcoal-600", "w-1/2 py-2 px-8 text-center rounded-[10px] cursor-pointer")}>{t("general.BUY")}</div><div onClick={() => setSide(ASK)} className={cn(side === ASK ? "text-rojo-400 bg-rojo-50" : "text-charcoal-600", "w-1/2 py-2 px-8 text-center rounded-[10px] cursor-pointer")}>{t("general.SELL")}</div></div><div className="my-5"><ISelectCrypto isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} isDropDownOpen={isDropdownOpen} setIsDropDownOpen={setIsDropdownOpen} setSelectedCoin={setSelectedCoin} selectedCoin={selectedCoin} customDroDownClass="left-0 -top-5 z-50" label={t("general.CHOOSE_CRYPTO")} openType={isMobileView ? "modal" : "dropDown"} hasMarketData={true} walletData={walletAmounts} isLogin={!!token} /></div><div className="mb-5">{side === ASK ? <AmountInput value={amountValue} onChange={handleAmount} onKeyDown={handleKeyDownEvent} type="crypto" label={t("comparison.HEADER.CRYPTO_SALES_AMOUNT")} placeholder={`${t("comparison.HEADER.MINIMUM")} ${minMaxState?.min_symbol ? roundDown(minMaxState?.min_symbol, selectedCoin?.symbol) : "0"} ${t("comparison.HEADER.MAXIMUM")} ${minMaxState?.max_symbol ? roundDown(minMaxState?.max_symbol, selectedCoin?.symbol) : "0"}`} decimalLimit={selectedCoin && getFloatingPoint(selectedCoin?.symbol)} suffix={selectedCoin?.symbol} isLogin={!!token} balanceSymbol={selectedCoin?.symbol} walletBalance={selectedCoin ? walletAmounts?.[selectedCoin?.symbol] : 0} minAllowed={minMaxState?.min_symbol} maxAllowed={minMaxState?.max_symbol} selectedCoin={selectedCoin} errorTextMin={t("comparison.HEADER.LESS_AMOUNT_BUY_ERROR", {
                  minAmount: minMaxState?.min_symbol,
                  coin: selectedCoin?.symbol ?? ""
                })} errorTextMax={t("comparison.HEADER.MORE_AMOUNT_BUY_ERROR", {
                  maxAmount: minMaxState?.max_symbol,
                  coin: selectedCoin?.symbol ?? ""
                })} /> : <AmountInput value={amountValue} onChange={handleAmount} onKeyDown={handleKeyDownEvent} type="fiat" label={t("comparison.HEADER.CRYPTO_PURCHASE_AMOUNT_IN_FIAT")} placeholder={`${t("comparison.HEADER.MINIMUM")} ${minMaxState?.min_currency.toLocaleString() ?? "100,000"} ${t("comparison.HEADER.MAXIMUM")} ${minMaxState?.max_currency.toLocaleString() ?? "100,000,000"}`} decimalLimit={0} suffix={t("general.FIAT")} isLogin={!!token} balanceSymbol={t("general.FIAT")} walletBalance={walletAmounts?.IRT} minAllowed={minMaxState?.min_currency} maxAllowed={minMaxState?.max_currency} selectedCoin={selectedCoin} errorTextMin={t("comparison.HEADER.LESS_AMOUNT_BUY_ERROR", {
                  minAmount: minMaxState?.min_currency,
                  coin: selectedCoin?.symbol ?? ""
                })} errorTextMax={t("comparison.HEADER.MORE_AMOUNT_BUY_ERROR", {
                  maxAmount: minMaxState?.max_currency,
                  coin: selectedCoin?.symbol ?? ""
                })} />}</div><Button variant="solid" color="primary" size="lg" fullWidth={true} className="z-20 mt-7" disabled={amountValue === 0 || selectedCoin === null || isMinMaxAmount} onClick={handleSearch}>{side === BID ? "\u0645\u0642\u0627\u06CC\u0633\u0647 \u0648 \u062E\u0631\u06CC\u062F" : "\u0645\u0642\u0627\u06CC\u0633\u0647 \u0648 \u0641\u0631\u0648\u0634"}</Button></div><div className="px-3.5 py-5 md:p-6 bg-white rounded-[20px] my-[23px]"><p className="pb-[30px] font-bold text-[20px] text-charcoal-900">سرمایه گذاری آسان</p><p className="text-sm text-charcoal-900 leading-[24px]">با چند کلیک سبد سرمایه گذاری ارز دیجیتال خود را انتخاب و خرید کنید. سبدهای سرمایه گذاری آسان بیتمکس در 3 سطح "کم ریسک" ، "ریسک متوسط" و "ریسک بالا" به شما و با هر سطحی از ریسک‌پذیری امکان سرمایه‌گذاری آسان و مطمئن را در ارزهای دیجیتال می دهد .</p><Button fullWidth={true} variant="solid" color="primary" size="lg" className="z-20 mt-7 min-w-56" onClick={() => router.push("/invest/easy")}>سرمایه گذاری آسان</Button></div><div className="px-3.5 py-5 md:p-6 mb-6 bg-white rounded-[20px]"><p className="text-center font-bold text-[20px] text-charcoal-900">آخرین خرید و فروش</p><div className="flex flex-col gap-8 py-[20px]">{safeParseJson(lastOrders?.value, []).map(item_7 => <div key={`${item_7.exchange}-${item_7.date}-${item_7.symbol}-${item_7.currency}-${item_7.side}`} className="flex items-center justify-between"><div className="flex items-start gap-1">{renderExchangeIcon(item_7.exchange)}<div><p className="text-charcoal-900 text-sm font-bold">{exchangeNames[item_7.exchange] || item_7.exchange}</p><p className="text-charcoal-600 text-xs font-bold">{moment(item_7.date).format("HH:mm jYYYY/jMM/jDD")}</p></div></div><div className="flex flex-col items-end"><p className="text-charcoal-900 text-xs">{item_7.symbol} {roundDown(item_7.amount, item_7.symbol)}</p><p className={cn("font-bold text-sm pt-1", item_7.side === BID ? "text-aquamarine-400" : "text-rojo-400")}>{item_7.side === BID ? t("general.BUY") : t("general.SELL")}</p></div></div>)}</div></div></div></div></div></div> : "";
    $[61] = amountValue;
    $[62] = exchangeNames;
    $[63] = exchangesPdp?.description;
    $[64] = exchangesPdp?.exchange;
    $[65] = exchangesPdp?.name;
    $[66] = getFloatingPoint;
    $[67] = handleAmount;
    $[68] = handleKeyDownEvent;
    $[69] = handleSearch;
    $[70] = isChecking;
    $[71] = isDropdownOpen;
    $[72] = isMinMaxAmount;
    $[73] = isModalOpen;
    $[74] = lastOrders?.value;
    $[75] = minMaxState?.max_currency;
    $[76] = minMaxState?.max_symbol;
    $[77] = minMaxState?.min_currency;
    $[78] = minMaxState?.min_symbol;
    $[79] = roundDown;
    $[80] = router;
    $[81] = selectedCoin;
    $[82] = setSelectedCoin;
    $[83] = setSide;
    $[84] = side;
    $[85] = t;
    $[86] = token;
    $[87] = walletAmounts;
    $[88] = t25;
  } else {
    t25 = $[88];
  }
  return t25;
};
export default Index;
function _temp(item_0) {
  return item_0.symbol !== "IRT" && (item_0.name?.includes("-IRT") || item_0.name?.includes("IRT-"));
}
function _temp2(item_2) {
  return item_2.symbol === "USDT";
}
function _temp3(item_3) {
  return item_3.symbol !== "IRT" && (item_3.name?.includes("-IRT") || item_3.name?.includes("IRT-"));
}
function _temp4(item_4) {
  return item_4.symbol === "USDT";
}
function _temp5(prev) {
  return prev === undefined ? 0 : prev;
}
function _temp6(exchange) {
  const ExchangeFullIcon = getExchangeFullIcon(exchange);
  if (!ExchangeFullIcon) {
    return null;
  }
  return <ExchangeFullIcon className="w-8 h-8 md:w-10 md:h-10" />;
}
function _temp7(exchange_0) {
  const ExchangeIcon = getExchangeIcon(exchange_0);
  if (!ExchangeIcon) {
    return null;
  }
  return <ExchangeIcon className="w-6 h-6" />;
}